import React from 'react';
import { useLocation } from 'react-router-dom';
import * as S from './styles';
import RouteContainer from './components/RouteContainer';
import TabBar from './components/TabBar';
import IconTabBar from './components/IconTabBar';
import { Responsive } from '~/components';

export default function NavigationBar() {
  const location = useLocation();

  const isOpen = () => {
    return (
      location.pathname.includes('arbitration-team') ||
      location.pathname.includes('kit-selector') ||
      location.pathname.includes('grass-status') ||
      location.pathname.includes('match-sheet') ||
      location.pathname.includes('protocol-commercial-acts')
    );
  };

  return (
    <S.Container isOpen={isOpen()}>
      <Responsive
        sm={<IconTabBar isOpen={isOpen()} />}
        lg={<TabBar isOpen={isOpen()} />}
      />
      <RouteContainer />
    </S.Container>
  );
}
